// extracted by mini-css-extract-plugin
export var colorSquare = "_u0-0";
export var danger = "_u0-5";
export var lightPink = "_u0-8";
export var neutralBlue = "_u0-7";
export var neutralYellow = "_u0-6";
export var normal = "_u0-1";
export var primary = "_u0-2";
export var primaryLight = "_u0-3";
export var solidBlack = "_u0-g";
export var solidGreen = "_u0-b";
export var solidLightBlue = "_u0-d";
export var solidNavy = "_u0-c";
export var solidOrange = "_u0-f";
export var solidPink = "_u0-e";
export var solidRed = "_u0-9";
export var solidYellow = "_u0-a";
export var success = "_u0-4";